import React from 'react'

import './CrossSellingItem.scss'
import {ProductModel} from "../../Models/ProductModel";
import {useGetDiscount} from "../../hooks/useGetDiscount";
import Plus from '../../Assets/Icons/plus.svg'
import Moins from '../../Assets/Icons/moins.svg'

interface MenuItemProps {
    item: ProductModel,
    quantity: number,
    onAddItem: () => void
    onPlus: () => void
    onMoins: () => void
}

const CrossSellingItem: React.FC<MenuItemProps> = ({item, quantity, onAddItem, onPlus, onMoins}: MenuItemProps) => {
    const getDiscount = useGetDiscount()

    const discount = getDiscount(item.automaticDiscounts, new Date())

    const getQuantityDiscountText = () => {
        if(discount) {
            const achete = discount.discount.rate > 1 ? "achetés" : "acheté"
            const offert = discount.discount.rateTotal - discount.discount.rate > 1 ? "offerts" : "offert"
            return `${discount.discount.rate} ${achete} = ${discount.discount.rateTotal - discount.discount.rate} ${offert}`
        }
        return ''
    }

    return (
        <div className="crossSellingItem" >
            <div className="crossSellingItem__cadre">
                {
                    discount && (
                        <div className={`crossSellingItem__cadre__discount ${discount.discount.type === 'quantity' ? 'quantity' : 'percent'}`}>
                            {
                                discount.discount.type === 'quantity' ? (
                                    <p>{getQuantityDiscountText()}</p>
                                ) : (
                                    <p>-{discount.discount.rate}%</p>
                                )
                            }
                        </div>
                    )
                }
                <div className="crossSellingItem__cadre__imgContainer">
                    <img
                        src={item.product.image}
                        alt="item"
                    />
                </div>
            </div>
            {
                discount && discount.discount.type === 'percent' ? (
                    <p className="crossSellingItem--prix">{item.priceTTC - (item.priceTTC * (discount.discount.rate / 100))} € <span>{item.priceTTC} €</span></p>
                ) : (
                    <p className="crossSellingItem--prix">{item.priceTTC} €</p>
                )
            }
            <p className="crossSellingItem--name">{item.product.name}</p>
            {
                quantity === 0 ? (
                        <button  className="crossSellingItem--button" onClick={onAddItem}>
                            <img src={Plus}/>
                        </button>
                ) : (

                    <div className="crossSellingItem__buttonsContainer">
                        <div className="crossSellingItem__buttonsContainer__quantity"><p>{quantity}</p></div>
                        <img src={Moins} onClick={onMoins}/>
                        <img src={Plus} onClick={onPlus}/>
                    </div>
                )
            }
        </div>
    )
}

export default CrossSellingItem;
